import DbEngine from "./DbEngine";

// Fields: content, type, link, year
const publicationsDb = new DbEngine("publications");

// Fields: dept, number, section, title, semester, description, year, link, outline, id
const courseDb = new DbEngine("course");

// Fields: id, start_year, end_year, position, department, university, department_link, university_link
const academicPositionsDb = new DbEngine("academic_positions");

// Fields: title, year, link, id
const awardsDb = new DbEngine("awards");

// Fields: first_name, last_name, qualification, university,  id
const currentStudentDb = new DbEngine("current_students");

// Fields: name, title, completion_year, completion_month, university, id
const educationDb = new DbEngine("degrees");

// Fields: first_name, last_name, qualification, university, grad_year, current_status, id
const formerStudentsDb = new DbEngine("former_students");

// Fields: first_name, last_name, email, telephone, cv_link, office, position, department, description, photo, photo_navbar, university
const profileDb = new DbEngine("profile");

// Fields: title, duration, link, id, description
const researchFundingDb = new DbEngine("research_funding");

//Fields: title, link, id, description
const researchInterestDb = new DbEngine("research_interests");

//Fields: contents
const editorialAppointmentsDb = new DbEngine("editorial_appointments");

export {
  publicationsDb,
  courseDb,
  academicPositionsDb,
  awardsDb,
  currentStudentDb,
  educationDb,
  formerStudentsDb,
  profileDb,
  researchFundingDb,
  researchInterestDb,
  editorialAppointmentsDb,
};
